import moment from 'moment';

module.exports = {
  methods: {
    formatDateForEmail (value) {
      return moment(value).format('YYYY-MM-DD')
    },
    formatDateForWeb (date, time) {
      return (new Date(`${this.formatDateForEmail(date)}${time}`)).toISOString().replace(/-|:|\.\d\d\d/g,"")
    },
    generateEventLinks (client, title, description) {
      if (client == 'generic') {
        return `/calendar?title=${encodeURIComponent(title)}&description=${encodeURIComponent(description)}&location=${encodeURIComponent(this.address)}&dateTimeFrom=${this.formatDateForEmail(this.date)}T08:00:00&dateTimeTo=${this.formatDateForEmail(this.date)}T18:00:00`
      } else if (client == 'google') {
        return `https://calendar.google.com/calendar/r/eventedit?text=${encodeURIComponent(title)}&dates=${this.formatDateForWeb(this.date, 'T08:00:00')}/${this.formatDateForWeb(this.date, 'T18:00:00')}&details=${encodeURIComponent(description)}&location=${encodeURIComponent(this.address)}`
      } else if (client == 'outlook') {
        return `https://outlook.live.com/owa/?path=/calendar/action/compose&startdt=${this.formatDateForWeb(this.date, 'T08:00:00')}&enddt=${this.formatDateForWeb(this.date, 'T18:00:00')}&subject=${encodeURIComponent(title)}&location=${encodeURIComponent(this.address)}&body=${encodeURIComponent(description)}&allday=false&uid=`
      }
    }    
  }
}


// WEBPACK FOOTER //
// ./src/js/pickup/mixins/method-eventLinks.js